export default navigator.userAgent.indexOf('Mac') !== -1 ? 'Cmd' : 'Ctrl';
